import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useQuery, useMutation } from '@apollo/client';
import { View, Text } from 'react-native';
import { useParams } from 'react-router-dom';

import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { useNavigate } from 'app/src/utils/routing';

import AssignToUsers from './AssignToUsers';
import { UPDATE_ASSET} from './queries';
import SubNav from './SubNav';
import { AssetLeftContainer, AssetRightContainer, ButtonContainer } from './elements';
import {NewAssetDocuments} from '../Attachments/new';

const EditAsset = ({ asset, refetch, setShowModal }) => {
  const [submitting, setSubmitting] = useState();
  const [selectedSellerUsers, setSelectedSellerUsers] = useState([]);
  const [sellerDocuments, setSellerDocuments] = useState(
    asset.sellerDocuments?.map(file => {
      let notes = asset.sellerDocumentNotes.filter(note => {
        if(note.attachmentId === file.id) {
          return note.body
        }
      })
      return {
        id: file.id,
        filename: file.filename,
        url: file.url,
        notes: notes.length ? notes[0].body : null
      }
    }) || []
  );

  const [updateAsset] = useMutation(UPDATE_ASSET, {
    onCompleted: () => {
      setShowModal(false);
      refetch();
    }
  });
  const onSubmit = useCallback(input => {
    input['sellerUserIds'] = selectedSellerUsers;
    if(input['sellerDocuments']) {
      input['sellerDocumentNotes'] = input['sellerDocuments'].map(document => {
        return document.notes || ''
      });
      if(!input['sellerDocumentNotes']) {
        input['sellerDocumentNotes'] = [];
      }
      input['sellerDocuments'] = input['sellerDocuments'].map(document => {
        return document
      })
    }
    updateAsset({ variables: input });
    console.log('input', input)
  });

  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      id: asset.id,
      clientNumber: asset.clientNumber,
      sellerNotes: asset.sellerNotes || '',
      sellerDocuments: sellerDocuments,
      sellerDocumentNotes: asset.sellerDocumentNotes || []
    }
  });

  useEffect(() => {
    if (asset) {
      setSelectedSellerUsers(asset.assetSellerUsers.map(
        assetUser => assetUser.sellerUser.id
      ));
    }
  }, [asset]);

  if (submitting) { return <DataState.Loading />; }

  return (
    <View>
      <Input.Text
        label={`${asset.seller.clientNumberLabelFull}:`}
        name="clientNumber"
        control={control}
      />
      <Input.Text
        label="Seller Notes:"
        name="sellerNotes"
        control={control}
      />
      <Text
        style={{marginBottom: '-15px', fontSize: '16px'}}>
        Files:
      </Text>
      {/* <br />
        {expense.expenseFiles && expense.expenseFiles.map(file =>
          <View style={{width: 'fit-content'}}>
            <Link to={file.url} target='_blank'>
              <Text>
                {file.filename}
              </Text>
            </Link>
          </View>
        )} */}
      <View>
        <NewAssetDocuments
          recordId={null}
          recordType='Asset'
          attachmentType='Seller Document'
          refetch={refetch}
          name='sellerDocuments'
          setValue={setValue}
          existingFiles={sellerDocuments}
          existingFileNotes={asset?.sellerDocumentNotes}
        />
      </View>
      <AssignToUsers
        selectedSellerUsers={selectedSellerUsers}
        setSelectedSellerUsers={setSelectedSellerUsers}
      />
      <ButtonContainer>
        <ButtonGroup>
          <Button label="Update Asset" onPress={handleSubmit(onSubmit)} />
        </ButtonGroup>
      </ButtonContainer>
    </View>
  );
};

export default EditAsset;
